import { create } from "apisauce";
import { getToken } from "helper/storage";

export const apiClient = create({
  baseURL: "https://api-oxin.dadekavweb.ir/api", //test
  // baseURL: "http://127.0.0.1:8000/api", //test
});

apiClient.addAsyncRequestTransform(async (request) => {
  let authToken = await getToken();
  if (!authToken) return;

  request.headers["Authorization"] = "Bearer " + authToken;
});
export default apiClient;
